import { FC } from 'react'
import { Chip, makeStyles } from '@material-ui/core'
import { strings } from './strings'
import { useDeleteMountpointGroup, useDeleteUserGroup } from './api'

interface GroupFormProps {
  groupId: number | null
  groupType: 'user' | 'mountpoint'
}

export const GroupForm: FC<GroupFormProps> = ({ groupId, groupType }) => {
  const classes = useStyles()
  const deleteUserGroup = useDeleteUserGroup()
  const deleteMountpointGroup = useDeleteMountpointGroup()

  if (!groupId) {
    return null
  }

  return (
    <div className={classes.root}>
      <Chip label={strings.renameGroup} clickable />
      <Chip
        label={strings.deleteGroup}
        clickable
        onClick={() => {
          if (groupType === 'user') {
            deleteUserGroup(groupId).then()
          } else if (groupType === 'mountpoint') {
            deleteMountpointGroup(groupId).then()
          }
        }}
      />
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
}))
